export const SEND_OTP = 'SEND_OTP';
export const VERIFY_OTP = 'VERIFY_OTP';
export const RESET_PASSWORD = 'RESET_PASSWORD';
export const ERROR = "ERROR";
export const LOGOUT= "LOGOUT";